var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-translate',{attrs:{"placeholder":"エラーが発生しました。ログインし直してください。","text-key":"hall-0202"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }